export default function mapRegisterPayload(values) {
  return {
    full_name: values.fullName.trim(),
    email: values.email.trim().toLowerCase(),
    mobile: values.mobileNumber.trim(),
    acceptTerms: values.acceptTerms,
  };
}